import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { ISingleTransfer } from '../../../types/transfer';
import { RootState } from '../..';

interface IGetSingleTransfersResponse {
  status?: boolean;
  message?: string;
  data?: ISingleTransfer[];
  meta?: {
    total?: number;
    perPage?: number;
    totalPages?: number;
    page?: number;
  };
  errors?: IApiResponseError[];
}

const initialState: IApiState<IGetSingleTransfersResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getSingleTransfersAsync = createAsyncThunk(
  'singleTransfers',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;

      const businessId = localStorage.getItem('businessId');

      const accountNumber = localStorage.getItem('accountNumber');

      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      let response;

      if (accountNumber) {
        response = await api.get(
          `/transfers/accounts/${accountNumber}/transactions`,
          config
        );
      }

      return response?.data ?? null;
    } catch (err) {
      const error = err as AxiosError<IApiResponseError>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const singleTransfersGetSlice = createSlice({
  name: 'singleTransfers/get',
  initialState,
  reducers: {
    resetGetSingleTransfers: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSingleTransfersAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(getSingleTransfersAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IGetSingleTransfersResponse;
      })
      .addCase(getSingleTransfersAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IGetSingleTransfersResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetGetSingleTransfers } = singleTransfersGetSlice.actions;

export default singleTransfersGetSlice.reducer;
